<template>

  <div>

    <div id="message-dialog" class="ui small modal message-modal">

      <div class="ui header">
        Enviar Mensagem
      </div>

      <div class="content">

        <form class="ui form" @submit.prevent="onSend()">
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Para os usuários</label>
              <select id="select-users" class="ui fluid search dropdown" multiple="" v-model="message.toUsers">
                <option v-for="user in users" :value="user.id">{{ user.name }}</option>
              </select>
            </div>
          </div>
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Para os grupos</label>
              <select id="select-groups" class="ui fluid search dropdown" multiple="" v-model="message.toGroups">
                <option v-for="group in groups" :value="group.id">{{ group.name }}</option>
              </select>
            </div>
          </div>
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Assunto</label>
              <input type="text" v-model="message.subject">
            </div>
          </div>
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Mensagem <span class="red text">*</span></label>
              <textarea id="message-text" rows="6" v-model="message.text"></textarea>
            </div>
          </div>
        </form>

      </div>

      <div class="actions">
        <button class="ui cancel basic button">
          <i class="times icon"></i>
          Cancelar
        </button>
        <button type="button" class="ui blue button" :class="{ loading: sending }" @click="onSend()">
          <i class="check icon"></i>
          Enviar
        </button>
      </div>

    </div>

  </div>

</template>

<script>

  import MessageService from "@/services/message-service"
  import { cleanSpecialChars, Message } from "@/utils"

  export default {

    data() {
      return {
        sending: false,
        users: [],
        groups: [],
        message: {
          toUsers: [],
          toGroups: [],
          subject: "",
          text: "",
        },
      }
    },

    beforeDestroy() {
      $(".message-modal").remove()
    },

    created() {
      this.loadUsers()
      this.loadGroups()
    },

    mounted() {

      $("#message-dialog").modal({
        autofocus: false,
      })

      $("#select-users").dropdown()
      $("#select-groups").dropdown()
    },

    methods: {

      async loadUsers() {

        try {

          const response = await MessageService.getUsers()

          this.users = response.users

        } catch (error) {

          this.$errorHandler(error, { silent: true })
        }
      },

      async loadGroups() {

        try {

          const response = await MessageService.getGroups()

          this.groups = response.groups

        } catch (error) {

          this.$errorHandler(error, { silent: true })
        }
      },

      async onSend() {

        if (!this.validData())
          return

        this.sending = true

        try {

          this.message.subject = cleanSpecialChars(this.message.subject)
          this.message.text = cleanSpecialChars(this.message.text)
          this.message.text = this.message.text.replace(/(\r\n|\n|\r)/gm, "<br/>")

          await MessageService.create(this.message)

          $("#message-dialog").modal("hide")

          this.message = {
            toUsers: [],
            toGroups: [],
            subject: "",
            text: "",
          }

          this.sending = false

          $("#select-users").dropdown("clear")
          $("#select-groups").dropdown("clear")

          Message.success("Mensagem enviada com sucesso")

        } catch (error) {

          this.sending = false
          this.$errorHandler(error)
        }
      },

      validData() {

        let isOk = true
        let message = ""

        if ((this.message.toUsers.length + this.message.toGroups.length) == 0) {
          message = "Nenhum destinatário selecionado"
        } else if (!this.message.text) {
          message = "Informe o texto da mensagem"
        }

        if (message) {
          isOk = false
          Message.info(message)
        }

        return isOk
      },
    },
  }

</script>
